// src/Layout/MainLayout.js
import React, { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

// Se han removido "Contacto" y "Legal" de la navegación superior
const navItems = [
  { label: "Inicio", to: "/" },
  { label: "Calculadora Materiales", to: "/calculadora-materiales" },
  { label: "Estimador Costos", to: "/presupuestador-obras" },
  { label: "Historico Precios", to: "/historico-precios" },
  // { label: "Hormigon Armado", to: "/hormigon-armado" }, // habilitar cuando termine el modulo
];

export default function MainLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleToggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* Barra superior */}
      <AppBar component="nav" position="fixed">
        <Toolbar>
          {/* Botón hamburguesa (solo visible en xs/sm) */}
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleToggleDrawer}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {/* Logo + Nombre + Lema (clicable para ir a "/") */}
          <Box
            component={Link}
            to="/"
            sx={{
              display: "flex",
              alignItems: "center",
              flexGrow: 1, // Empuja los enlaces a la derecha
              textDecoration: "none", // Quita subrayado
              color: "inherit", // Hereda color blanco del AppBar
            }}
          >
            <Box
              component="img"
              src="/images/logo-app.png"
              alt="Logo"
              sx={{ height: 50, mr: 2 }}
            />
            {/* Nombre de la app y lema */}
            <Box>
              <Typography
                variant="h6"
                sx={{ fontFamily: "'Bebas Neue', sans-serif", lineHeight: 1 }}
              >
                Calcu Obra Arg
              </Typography>
              <Typography
                variant="caption"
                sx={{ fontStyle: "italic", lineHeight: 1 }}
              >
                simplificando su proyecto
              </Typography>
            </Box>
          </Box>

          {/* Links en la barra (versión desktop) */}
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                style={{
                  textDecoration: "none",
                  color: "white",
                  margin: "0 10px",
                }}
              >
                {item.label}
              </Link>
            ))}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer (versión móvil) */}
      <Drawer
        variant="temporary"
        open={drawerOpen}
        onClose={handleToggleDrawer}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: 240 },
        }}
      >
        <List>
          {navItems.map((item) => (
            <ListItemButton
              key={item.label}
              onClick={handleToggleDrawer}
              component={Link}
              to={item.to}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>

      {/* Contenido principal (rutas hijas) */}
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Outlet />
      </Box>
    </Box>
  );
}